const track = document.querySelector('.list-collections > .container');
const prevBtn = document.querySelector('.carousel-arrow.prev');
const nextBtn = document.querySelector('.carousel-arrow.next');

const scrollAmount = 320; // should match card width

nextBtn.addEventListener('click', () => {
  track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
});

prevBtn.addEventListener('click', () => {
  track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
});

function updateArrows() {
  prevBtn.style.display = track.scrollLeft > 0 ? 'flex' : 'none';
  nextBtn.style.display =
    track.scrollLeft + track.clientWidth < track.scrollWidth
      ? 'flex'
      : 'none';
}

track.addEventListener('scroll', updateArrows);
window.addEventListener('resize', updateArrows);
updateArrows();